function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import MultiChoiceFilter from './MultiChoiceFilter';
export default function TextFilter(_ref) {
  let {
    initialValue = '',
    onFilter,
    showPlusButton = false,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MultiChoiceFilter, _extends({
    initialValue: initialValue,
    onFilter: onFilter,
    showPlusButton: showPlusButton,
    type: "text"
  }, props));
}